/**
 * MFAC variant ↔ MODEL_3D swapper (native Shopify — no CartMagician)
 * CRASH FIX: themes emit EXACTLY ONE model-viewer; this JS updates its src/ios-src
 * + data-shopify-model3d-id from MfacVariantModelMap on variant change.
 */
(function () {
  'use strict';

  var MAP_PREFIX = 'MfacVariantModelMap-';
  var ATTR_MODEL_ID = 'data-shopify-model3d-id';
  var ATTR_ACTIVE = 'data-mfac-active-model';

  function parseMap(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function findMaps() {
    var nodes = document.querySelectorAll('script[type="application/json"][id^="' + MAP_PREFIX + '"]');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      var map = parseMap(nodes[i]);
      if (!map || !map.byVariantId) continue;
      var sectionId = nodes[i].id.slice(MAP_PREFIX.length);
      out.push({ sectionId: sectionId, el: nodes[i], map: map });
    }
    return out;
  }

  function resolveEntry(map, variant) {
    if (!map || !variant) return null;
    var byId = map.byVariantId || {};
    var byTitle = map.byVariantTitle || {};
    var idKey = String(variant.id);
    if (byId[idKey]) return byId[idKey];
    if (variant.title && byTitle[variant.title]) return byTitle[variant.title];
    return null;
  }

  function rootForSection(sectionId) {
    return (
      document.getElementById('ProductSection-' + sectionId) ||
      document.querySelector('[data-section-id="' + sectionId + '"]') ||
      document.querySelector('#ProductPhotos-' + sectionId)?.closest('[data-product-images]')?.parentElement ||
      document
    );
  }

  function updateViewer(mv, entry) {
    if (!mv || !entry) return;
    if (entry.glb) mv.setAttribute('src', entry.glb);
    if (entry.usdz) mv.setAttribute('ios-src', entry.usdz);
    else if (entry.usdz === '') mv.removeAttribute('ios-src');
    if (entry.alt) mv.setAttribute('alt', entry.alt);
    if (entry.poster) mv.setAttribute('poster', entry.poster);
    mv.setAttribute('data-model-id', String(entry.id));
    mv.setAttribute(ATTR_ACTIVE, 'true');
    mv.setAttribute('data-mfac-single-model-viewer', '');
    var wrap = mv.closest('[data-product-media-type-model], .product__model-xr-source');
    if (wrap) {
      var sec = wrap.getAttribute('data-media-id') || '';
      var prefix = sec.indexOf('-') !== -1 ? sec.split('-')[0] : '';
      if (prefix) wrap.setAttribute('data-media-id', prefix + '-' + entry.id);
      else wrap.setAttribute('data-media-id', String(entry.id));
    }
  }

  function applyModel(sectionId, entry, map) {
    if (!entry || !entry.id) return false;
    var root = rootForSection(sectionId);
    var xr =
      root.querySelector('[data-mfac-variant-model-swapper], [data-shopify-xr]') ||
      document.querySelector('[data-mfac-variant-model-swapper], [data-shopify-xr]');
    if (xr) {
      xr.setAttribute(ATTR_MODEL_ID, String(entry.id));
      xr.setAttribute(ATTR_ACTIVE, String(entry.id));
    }

    // Prefer the single crash-fix viewer
    var single =
      root.querySelector('model-viewer[data-mfac-single-model-viewer]') ||
      document.querySelector('model-viewer[data-mfac-single-model-viewer]');
    if (single) {
      updateViewer(single, entry);
    } else {
      // Fallback: update matching id, else first viewer
      var viewers = root.querySelectorAll('model-viewer[data-model-id], [data-product-media-type-model] model-viewer');
      if (!viewers.length) viewers = document.querySelectorAll('model-viewer[data-model-id]');
      var matched = null;
      for (var i = 0; i < viewers.length; i++) {
        var mv = viewers[i];
        if (String(mv.getAttribute('data-model-id') || '') === String(entry.id)) {
          matched = mv;
          updateViewer(mv, entry);
        } else {
          mv.removeAttribute(ATTR_ACTIVE);
        }
      }
      if (!matched && viewers.length) updateViewer(viewers[0], entry);
    }

    if (map) map._lastAppliedId = String(entry.id);
    return true;
  }

  function onVariant(variant, preferredSectionId) {
    if (!variant) return;
    var maps = findMaps();
    if (!maps.length) return;
    for (var i = 0; i < maps.length; i++) {
      var item = maps[i];
      if (preferredSectionId && item.sectionId !== String(preferredSectionId)) continue;
      var entry = resolveEntry(item.map, variant);
      if (!entry) continue;
      applyModel(item.sectionId, entry, item.map);
      if (preferredSectionId) break;
    }
  }

  function bootstrap() {
    var maps = findMaps();
    for (var i = 0; i < maps.length; i++) {
      var item = maps[i];
      var initial = item.map.initial || null;
      if (initial && initial.id) applyModel(item.sectionId, initial, item.map);
    }
  }

  function variantFromEvent(evt) {
    if (!evt || !evt.detail) return null;
    return evt.detail.variant || (evt.detail.detail && evt.detail.detail.variant) || null;
  }

  function sectionIdFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var sec = target.closest('[data-section-id]');
    return sec ? sec.getAttribute('data-section-id') : null;
  }

  document.addEventListener('variantChange', function (evt) {
    onVariant(variantFromEvent(evt), sectionIdFromEventTarget(evt.target));
  });
  document.addEventListener('variant:change', function (evt) {
    onVariant(variantFromEvent(evt), sectionIdFromEventTarget(evt.target));
  });
  document.addEventListener(
    'variantChange',
    function (evt) {
      onVariant(variantFromEvent(evt), sectionIdFromEventTarget(evt.target));
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  window.MfacVariantModelSwapper = {
    apply: onVariant,
    maps: findMaps,
    resolve: resolveEntry
  };
})();
